import styled from 'styled-components';

export const Frame = styled.div<{ $color: string; $bgColor: string; $borderColor: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex: 1 1 0;
  min-width: 0;
  padding: 4px 8px;
  border-radius: 8px;
  background-color: ${({ $bgColor }) => $bgColor};
  border: 1px solid ${({ $borderColor }) => $borderColor};
  font-weight: 700;
  font-size: 10px;
  color: ${({ $color }) => $color};
`;

export const Icon = styled.span<{ $color: string; src: string }>`
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  background-color: ${({ $color }) => $color};
  -webkit-mask: url(${({ src }) => src}) center / contain no-repeat;
  mask: url(${({ src }) => src}) center / contain no-repeat;
`;
